export const menu = [
  // {
  //   Title: "Администрирование",
  //   Access: ["ADMIN"],
  //   Icon: "fa-cog",
  //   Pages: [
  //     {
  //       Title: "Регистрация пользователей",
  //       Path: "/admin/register_user",
  //       Icon: "fa-",
  //       Access: ["ADMIN"],
  //     },
  //   ],
  // },
  {
    Title: "Дашбоард",
    Access: ["ADMIN"],
    Path: "/Dashboard/",
    Icon: "fa-list",
    Pages: [],
  },
  {
    Title: "Списки",
    Access: ["ADMIN", "OPERATOR","DELIVERYMANAGER"],
    Icon: "fa-list",
    Pages: [
      {
        Title: "Клиенты",
        Path: "/clients/list",
        Icon: "fa-user",
        Access: ["ADMIN", "OPERATOR","DELIVERYMANAGER"],
      },
      {
        Title: "Пользователи",
        Path: "/users/list",
        Icon: "fa-user",
        Access: ["ADMIN"],
      },
      {
        Title: "Продукты",
        Path: "/products/list",
        Icon: "fa-product-hunt",
        Access: ["ADMIN"],
      },
    ],
  },
  {
    Title: "Заказы",
    Access: ["ADMIN","OPERATOR","DELIVERYMANAGER"],
    Icon: "fa-cog",
    Pages: [
      {
        Title: "Создать заказ",
        Path: "/orders/create",
        Icon: "fa-plus",
        Access: ["OPERATOR"],
      },
      {
        Title: "Список заказов",
        Path: "/orders/list",
        Icon: "fa-list",
        Access: ["ADMIN","OPERATOR","DELIVERYMANAGER"],
      },
    ],
  },
  {
    Title: "Отчеты",
    Access: ["ADMIN","CASHIER","DELIVERYMANAGER"],
    Icon: "fa-list",
    Pages: [
      {
        Title: "Отчеты по курьерам",
        Path: "/reports/CouriersDailyReports",
        Icon: "fa-user",
        Access: ["ADMIN","CASHIER","DELIVERYMANAGER"],
      },
 
    ],
  },
  {
    Title: "Тест",
    Access: ["ADMIN","OPERATOR","DELIVERYMANAGER"],
    Icon: "fa-list",
    Pages: [
      {
        Title: "2GIS",
        Path: "/test",
        Icon: "fa-user",
        Access: ["ADMIN","OPERATOR","DELIVERYMANAGER"],
      },
 
    ],
  },
];



// WEBPACK FOOTER //
// ./src/apiServices/menu.js